// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  --toastify-toast-width: 600px;
}

.dropdown-item-filter {
  cursor: pointer;
  font-size: 14px;
}
.bg-gray {
  background-color: #f4f4f4;
}

.ml-2 {
  margin-left: 0.5rem;
}

.pl-2 {
  padding-left: 0.5rem;
}

.pl-3 {
  padding-left: 1rem;
}

.mr-1 {
  margin-right: 0.125rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-3 {
  margin-right: 1rem;
}

.ml-auto {
  margin-left: auto;
}

.btn-disabled {
  pointer-events: none;
  opacity: 0.4;
}

.add-button,
.back-button {
  margin-left: 2em;
  font-size: 12px;
  font-weight: 600;
}

.main-sidebar {
  transform: none;
  transition: all 0.25s ease-in;
  position: sticky;
  z-index: 10;
}
.nav-link.overflow-unset {
  overflow: visible !important;
  overflow: initial !important;
}
.spinner {
  animation: none !important;
  border: none !important;
}

.form-label {
  font-weight: 600;
}

a {
  text-decoration: none !important;
}

.campaigns-infor {
  margin-top: -11px;
  margin-bottom: 2em;
  font-size: 10px;
}

.global-search {
  margin-top: 4px;
}

.avatar-space-right {
  margin-right: 13px;
}

.form-error {
  color: #ff0000;
  font-weight: 300;
  font-size: 12px;
  margin: 4px 2px;
}

.error-message {
  margin-top: 6px !important;
}

.radio-div {
  margin-left: 17px;
}

.loader-four {
  background: rgba(255, 255, 255, 0.5) none repeat scroll 0 0;
  float: left;
  min-height: 100%;
  position: fixed;
  text-align: center;
  width: 100%;
  z-index: 9999;
}

.modal {
  margin: auto;
}

.submitoverwrite {
  margin-bottom: 500px;
}
.keppingloaderPlace {
  display: flex;
}

.url-table {
  width: 100%;
  background-color: transparent;
  --bs-table-bg: transparent;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #212529;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #212529;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #212529;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: top;
  border-color: #dee2e6;
  caption-side: bottom;
  border-collapse: collapse;
}

.create-report-checkbox {
  margin-left: 0px;
}

.checkbox-label {
  margin-left: 10px;
}

.no-data {
  text-align: center;
  margin-top: 1%;
  margin-bottom: 1%;
}

.logout-button-color {
  color: red;
}

.cursor-pointer {
  cursor: pointer;
}

.mx-px {
  margin-right: 1px;
  margin-left: 1px;
}

.max-w-xl {
  max-width: 28rem;
}

.width {
  min-width: 100px;
}
.widthh {
  min-width: 110px;
}

.td {
  white-space: nowrap;
  max-width: 50px;
  overflow-x: hidden;
}

i.row-icons {
  cursor: pointer;
  font-size: 18px;
}

td {
  vertical-align: middle;
}

.vertical-align-middle {
  vertical-align: middle !important;
}

.text-right {
  text-align: right !important;
}

tfoot td {
  border-bottom: none !important;
}

.keyword-title {
  margin-left: 11px;
  margin-top: 27px;
  font-weight: 500;
}

.keyword-rank-title {
  font-weight: 500;
  margin-left: 10px;
  margin-top: 11px;
}

.link {
  cursor: pointer;
  color: #3273dc;
}

.react-datepicker__triangle {
  left: -16px !important;
}
.picture-preview {
  border: 1px solid #ccc;
  padding: 2px;
  max-width: 300px;
}
.loader-size {
  transform: scale(1.75);
}
.icon-size {
  margin-right: 12px;
  font-size: 15px;
}
.fetched-table {
  overflow: auto;
}
.error-position {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-route {
  color: #000;
}
.logo {
  flex-shrink: 0;
}
.url-table-row {
  display: grid;
  grid-template-columns: 35px 120px 120px auto 50px 50px 85px 85px 75px 75px 75px 75px 65px 65px;
  text-align: center;
  align-items: center;
}
.url-table-row:nth-child(even) {
  background-color: #eee;
}
.url-table-row > div {
  padding: 8px 4px;
}
.modal-dialog-scrollable .modal-content {
  overflow: auto;
}
.background-footer-model {
  background-color: rgb(0, 0, 0, 0.05);
}
.cancel-bg {
  background-color: white;
}
.fetch-text-size {
  font-size: 18px;
}
.text-left {
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,4BAA0B;EAA1B,4BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,0BAA0B;EAC1B,iCAAiC;EACjC,iCAAiC;EACjC,0CAA0C;EAC1C,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;EAC/B,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8FAA8F;EAC9F,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["body {\n  --toastify-toast-width: 600px;\n}\n\n.dropdown-item-filter {\n  cursor: pointer;\n  font-size: 14px;\n}\n.bg-gray {\n  background-color: #f4f4f4;\n}\n\n.ml-2 {\n  margin-left: 0.5rem;\n}\n\n.pl-2 {\n  padding-left: 0.5rem;\n}\n\n.pl-3 {\n  padding-left: 1rem;\n}\n\n.mr-1 {\n  margin-right: 0.125rem;\n}\n\n.mr-2 {\n  margin-right: 0.5rem;\n}\n\n.mr-3 {\n  margin-right: 1rem;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.btn-disabled {\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n.add-button,\n.back-button {\n  margin-left: 2em;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.main-sidebar {\n  transform: none;\n  transition: all 0.25s ease-in;\n  position: sticky;\n  z-index: 10;\n}\n.nav-link.overflow-unset {\n  overflow: unset !important;\n}\n.spinner {\n  animation: none !important;\n  border: none !important;\n}\n\n.form-label {\n  font-weight: 600;\n}\n\na {\n  text-decoration: none !important;\n}\n\n.campaigns-infor {\n  margin-top: -11px;\n  margin-bottom: 2em;\n  font-size: 10px;\n}\n\n.global-search {\n  margin-top: 4px;\n}\n\n.avatar-space-right {\n  margin-right: 13px;\n}\n\n.form-error {\n  color: #ff0000;\n  font-weight: 300;\n  font-size: 12px;\n  margin: 4px 2px;\n}\n\n.error-message {\n  margin-top: 6px !important;\n}\n\n.radio-div {\n  margin-left: 17px;\n}\n\n.loader-four {\n  background: rgba(255, 255, 255, 0.5) none repeat scroll 0 0;\n  float: left;\n  min-height: 100%;\n  position: fixed;\n  text-align: center;\n  width: 100%;\n  z-index: 9999;\n}\n\n.modal {\n  margin: auto;\n}\n\n.submitoverwrite {\n  margin-bottom: 500px;\n}\n.keppingloaderPlace {\n  display: flex;\n}\n\n.url-table {\n  width: 100%;\n  background-color: transparent;\n  --bs-table-bg: transparent;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: #212529;\n  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n  --bs-table-active-color: #212529;\n  --bs-table-active-bg: rgba(0, 0, 0, 0.1);\n  --bs-table-hover-color: #212529;\n  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);\n  margin-bottom: 1rem;\n  color: #212529;\n  vertical-align: top;\n  border-color: #dee2e6;\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\n.create-report-checkbox {\n  margin-left: 0px;\n}\n\n.checkbox-label {\n  margin-left: 10px;\n}\n\n.no-data {\n  text-align: center;\n  margin-top: 1%;\n  margin-bottom: 1%;\n}\n\n.logout-button-color {\n  color: red;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.mx-px {\n  margin-right: 1px;\n  margin-left: 1px;\n}\n\n.max-w-xl {\n  max-width: 28rem;\n}\n\n.width {\n  min-width: 100px;\n}\n.widthh {\n  min-width: 110px;\n}\n\n.td {\n  white-space: nowrap;\n  max-width: 50px;\n  overflow-x: hidden;\n}\n\ni.row-icons {\n  cursor: pointer;\n  font-size: 18px;\n}\n\ntd {\n  vertical-align: middle;\n}\n\n.vertical-align-middle {\n  vertical-align: middle !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\ntfoot td {\n  border-bottom: none !important;\n}\n\n.keyword-title {\n  margin-left: 11px;\n  margin-top: 27px;\n  font-weight: 500;\n}\n\n.keyword-rank-title {\n  font-weight: 500;\n  margin-left: 10px;\n  margin-top: 11px;\n}\n\n.link {\n  cursor: pointer;\n  color: #3273dc;\n}\n\n.react-datepicker__triangle {\n  left: -16px !important;\n}\n.picture-preview {\n  border: 1px solid #ccc;\n  padding: 2px;\n  max-width: 300px;\n}\n.loader-size {\n  transform: scale(1.75);\n}\n.icon-size {\n  margin-right: 12px;\n  font-size: 15px;\n}\n.fetched-table {\n  overflow: auto;\n}\n.error-position {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.no-route {\n  color: #000;\n}\n.logo {\n  flex-shrink: 0;\n}\n.url-table-row {\n  display: grid;\n  grid-template-columns: 35px 120px 120px auto 50px 50px 85px 85px 75px 75px 75px 75px 65px 65px;\n  text-align: center;\n  align-items: center;\n}\n.url-table-row:nth-child(even) {\n  background-color: #eee;\n}\n.url-table-row > div {\n  padding: 8px 4px;\n}\n.modal-dialog-scrollable .modal-content {\n  overflow: auto;\n}\n.background-footer-model {\n  background-color: rgb(0, 0, 0, 0.05);\n}\n.cancel-bg {\n  background-color: white;\n}\n.fetch-text-size {\n  font-size: 18px;\n}\n.text-left {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
